/**
 * Storage class
 */
class Storage {
  /**
   * Set storage item
   * @param {String} key key
   * @param {Any} value value
   */
  set(key, value) {
    let _value = value

    // Objects and arrays must be stringified
    if (typeof value === 'object') {
      _value = JSON.stringify(value)
    }

    localStorage.setItem(key, _value)
  }

  /**
   * Get storage item
   * @param {String} key key
   * @param {Any} notFound value if key not found
   * @returns {Any}
   */
  get(key, notFound = null) {
    let item = localStorage.getItem(key)

    try {
      item = JSON.parse(item)
    } catch (error) { }

    return !item ? notFound : item
  }

  /**
   * Remove item from storage
   * @param {String} key key
   */
  remove(key) {
    localStorage.removeItem(key)
  }

  /**
   * Clear all storage items
   */
  clear() {
    localStorage.clear()
  }
}

export default new Storage()
